/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REGISTER_PLACEHOLDER } from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CountryId } from '../models/country-id';
import { CountryDto } from '../models/country.dto';
import { EnabledAndDisabledPoolsDto } from '../models/enabled-and-disabled-pools.dto';
import { EnabledPoolDto } from '../models/enabled-pool.dto';
import { RegisterDto } from '../models/register.dto';

@Injectable({
  providedIn: 'root',
})
export class RegisterApi {
  constructor(private http: HttpClient) {}

  enabledPools(options: { registerId?: number } = {}): Observable<EnabledPoolDto[]> {
    return this.http.get<EnabledPoolDto[]>(
      `${environment.servicesApiUrl}/api/v1/register/${options.registerId ?? REGISTER_PLACEHOLDER}/enabled-pools`,
    );
  }

  export(options: { registerId?: number } = {}): Observable<Blob> {
    return this.http.get(
      `${environment.servicesApiUrl}/api/v1/register/${options.registerId ?? REGISTER_PLACEHOLDER}/export`,
      { responseType: 'blob' },
    );
  }

  get(): Observable<RegisterDto> {
    return this.http.get<RegisterDto>(`${environment.servicesApiUrl}/api/v1/register`);
  }

  getCountries(query: { includeCountryId?: CountryId } = {}): Observable<CountryDto[]> {
    return this.http.get<CountryDto[]>(`${environment.servicesApiUrl}/api/v1/register/countries`, {
      params: query,
    });
  }

  getFirstDayOfCurrentFinancialYear(): Observable<string> {
    return this.http.get<string>(`${environment.servicesApiUrl}/api/v1/register/finyear-start`);
  }

  poolSettings(options: { registerId?: number } = {}): Observable<EnabledAndDisabledPoolsDto> {
    return this.http.get<EnabledAndDisabledPoolsDto>(
      `${environment.servicesApiUrl}/api/v1/register/${options.registerId ?? REGISTER_PLACEHOLDER}/pools`,
    );
  }

  saveEnabledPools(
    enabledAndDisabledPools: EnabledAndDisabledPoolsDto,
    options: { registerId?: number } = {},
  ): Observable<EnabledAndDisabledPoolsDto> {
    return this.http.put<EnabledAndDisabledPoolsDto>(
      `${environment.servicesApiUrl}/api/v1/register/${options.registerId ?? REGISTER_PLACEHOLDER}/pools`,
      enabledAndDisabledPools,
    );
  }

  wasSwitched(nextActiveRegisterId: number): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v1/register/was-switched/${nextActiveRegisterId}`,
      {},
    );
  }
}
